export const assistantRows = [
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
  {
    id: 1,
    AssistantName: "Darlene Robertson",
    NumCardsMade: 40,
    ErrorMade: "02",
    ManualEntry: 70,
  },
];

export const assistantColumns = [
  {
    field: "AssistantName",
    headerName: "Assistant Name",
    width: 400,
  },
  {
    field: "NumCardsMade",
    headerName: "Num. Cards Made",
    width: 400,
  },
  { field: "ErrorMade", headerName: "Error Made", width: 350 },
  { field: "ManualEntry", headerName: "Manual Entry", width: 350 },
];

export const pharmacistRows = [
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
  {
    id: 1,
    PharmacistName: "Darlene Robertson",
    NumCardsChecked: "40",
    ErrorFounded: "08",
  },
];

export const pharmacistColumns = [
  { field: "PharmacistName", headerName: "Pharmacist Name", width: 500 },
  { field: "NumCardsChecked", headerName: "Num. Cards Checked", width: 500 },
  { field: "ErrorFounded", headerName: "Error Founded", width: 500 },
];
